// extracted by mini-css-extract-plugin
module.exports = {"header":"_3gN5ZWWk7oN3XweZ9jYj8p","dialog":"_2UR6xZvqftx8Rx-2_73n0E","no-button":"_3YJtJpIvXTkPqXRkrd5qlj","yes-button":"_1K7yKSRinsPSr71vzwiFez"};